import Vue from 'vue';
import Router from 'vue-router';
// import VueAnalytics from 'vue-analytics';
// import VueAppInsights from 'vue-application-insights'
import VueGtm from 'vue-gtm';

import umbracoPage from "./umbracopage.vue";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    // saveScrollPosition: true,
    base: '/',//process.env.BASE_URL,

    scrollBehavior (to, from, savedPosition) {
        // console.log("saved", savedPosition);
        if (savedPosition)
        {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                  resolve(savedPosition)
                }, 500)
              })
            // console.log("scroll pos", savedPosition);
            // return savedPosition;
        }
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/checkout/info',
            component: () => import(/* webpackChunkName: "viewInfo" */ './views/checkoutInfo.old.vue')
            // component: () => window["expVar"] == 0 ? 
            // import(/* webpackChunkName: "viewInfo" */ './views/checkoutInfo.vue') : 
            // import(/* webpackChunkName: "viewInfo" */ './views/checkoutInfo.bokse.vue'),
        },
        {
            path: '/checkout/kvittering',
            component: () => import(/* webpackChunkName: "viewKvittering" */ './views/checkoutKvittering.vue'),
        },
        {
            path: '/basket',
            component: () => import(/* webpackChunkName: "viewBasket" */ './views/basket.vue'),
        },
        {
            path: '/searchresults',
            component: () => import(/* webpackChunkName: "viewSearchresults" */ './views/searchresults.vue'),
        },
        {
            path: '/find-butik',
            component: () => import(/* webpackChunkName: "viewFindbutik" */ './views/findButik.vue'),
        },
        {
            path: '/reserver/*',
            component: () => import(/* webpackChunkName: "viewReserver" */ './views/reserver.vue'),
        },
        {
            path: '*',
            component: umbracoPage
        }
    ],
});

router.afterEach((to, from) => {
    // console.log("afterEach", document.location.origin + to.path);  
    window["dataLayer"] && window["dataLayer"].push({
        event: 'pageView',
        'path': document.location.origin + to.path   
    })
});

var isProd = process.env.NODE_ENV == "production" && document.location.href.indexOf("localhost")<0;

// Vue.use(VueAppInsights, {
//     id: '3b281b1a-e880-4384-ab8e-ba3943eb18e3',
//     router
// });

Vue.use(VueGtm, {
    id: 'GTM-WG28Q7H', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
    //   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
    //   gtm_preview:'env-4',
    //   gtm_cookies_win:'x'
    // },
    defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: !isProd, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    // ignoredViews: ['homepage'], // Don't trigger events for specified router names (case insensitive) (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  });

export default router;